import { openDialog } from 'vue3-promise-dialog';
import MsMessageBox from '@/components/messageBox/MsMessageBox.vue';

function getMsgOption(type, message, title, width, textBtn) {
  if (typeof message === 'object' && message.message) {
    return { ...message, ...{ type } };
  } else {
    return {
      type,
      message: message,
      title: title,
      width,
      textBtn,
    };
  }
}

function getMsgOptionCustom(type, message, title, customTextButton, width) {
  if (typeof message === 'object' && message.message) {
    return { ...message, ...{ type } };
  } else {
    return { type, message: message, title: title, customTextButton, width };
  }
}

export function showAlert(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(0, message, title, width));
}
export function showInfo(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(0, message, title, width));
}
export function showSuccess(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(0, message, title, width));
}
export function showError(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(0, message, title, width));
}
export function showConfirm(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(1, message, title, width));
}
export function showConfirmCancel(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(2, message, title, width));
}
export function showConfirmDelete(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(3, message, title, width));
}
export function showErrorCustom(message, title, type, width) {
  return openDialog(MsMessageBox, getMsgOption(type, message, title, width));
}
export function showConfirmValidate(message, title, customTextButton, width) {
  return openDialog(
    MsMessageBox,
    getMsgOptionCustom(5, message, title, customTextButton, width)
  );
}
export function showConfirmValidateCustom(message, title, textBtn, width) {
  return openDialog(
    MsMessageBox,
    getMsgOption(6, message, title, width, textBtn)
  );
}
/**
 * Dialog show confirm với checkbox không hiển thị lại lần sau
 * TVDAT 05.07.2022
 */
export function showConfirmWithDontShowAgain(
  message,
  title,
  customLabelIsShowMessage,
  textBtn,
  width
) {
  return openDialog(MsMessageBox, {
    type: 7,
    message,
    title,
    width,
    textBtn,
    customLabelIsShowMessage
  });
}

export function showIncurredDataWarning(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(8, message, title, width));
}

export function showChooseOptionConfirm(message, optionList, title, width) {
  return openDialog(MsMessageBox, {
    type: 9,
    message: message,
    title: title,
    width,
    optionList,
    width: 500
  });
}
